import { shallowMount } from "@vue/test-utils";
import BannerMODOOferta from "@/components/core/custom/BannerMODOOferta.vue";

describe("BannerMODOOferta component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(BannerMODOOferta);
  });

  it("Renders del component BannerMODOOferta", () => {
    expect(wrapper).toBeDefined();
  });

  it("Debe de establecer el valor por defecto", () => {
    expect(wrapper.text()).toContain("");
  });
});
